import type { ListOutput } from '@allocab/allocab-standard-shared-types';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { ExtranetUserOutput, MembersListInput } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';
import { extranetQueryKeys } from '../queryKeys';

/**
 * `GET /v1/users` — les membres extranet du compte, déduit de la session.
 * Depuis la v1.9.0 la réponse est un `ListOutput` : `totalItems` permet une
 * vraie pagination.
 */
export const useMembers = (input: MembersListInput) =>
  useQuery<ListOutput<ExtranetUserOutput>>({
    queryKey: extranetQueryKeys.members.list(input),
    queryFn: () => getExtranetApi().get<MembersListInput, ListOutput<ExtranetUserOutput>>('/v1/users', input),
    placeholderData: keepPreviousData,
  });
